@use "../../styles/breakpoint.module.scss" as *;

.section {
    background-color: var(--off-white);
    padding-block: var(--spacer-80);
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    position: relative;

    @media ($above-tablet) {
        height: calc(100vh - var(--main-nav-height));
        max-height: 800px;
        grid-template-rows: auto 1fr;
    }
}

// --- Left column on desktop, full-width on mobile ---

.searchArea {
    grid-column: 2 / span 5;

    @media ($above-tablet) {
        grid-row: 1;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.locationList {
    grid-column: 2 / span 5;

    @media ($above-tablet) {
        grid-row: 2;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
        margin-inline: calc(-1 * var(--labui-container-margin));
    }
}

.jumpToResults {
    display: none;

    @media ($below-tablet) {
        display: block;
        grid-column: 1 / -1;
        font: var(--font-eyebrow-14);
        color: var(--red);
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 0.1em;
    }
}

// --- Right column on desktop, full-width on mobile ---

.distanceSelect {
    display: flex;
    flex-direction: column;
    grid-column: 7 / span 5;
    justify-content: center;

    @media ($above-tablet) {
        grid-row: 1;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.map {
    position: relative;
    grid-column: 7 / span 5;
    height: 100%;
    min-height: 634px;

    @media ($above-tablet) {
        grid-row: 2;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
        height: 50vh;
        margin-inline: calc(-1 * var(--labui-container-margin));
    }
}

// --- Shared ---

.locationError {
    font: var(--font-p-16);
    margin-block: var(--spacer-16);
}
